import React from 'react';
import clsx from 'clsx';

// The rounded-2xl bordered white container used throughout (gate cards,
// announcement rows, list items) — was hand-written per page with small,
// unintentional differences in radius/shadow/border color. `accent` gives
// the colored left-border-stripe treatment used to flag state at a glance
// (e.g. an interrupted/emergency-paused session) without needing a caller
// to know the exact border-l-4 + color-token incantation.
export default function Card({
  as: Component = 'div',
  accent, // e.g. 'border-l-amber-500' — full class string, left-edge state stripe
  interactive = false, // hover lift + pointer, for clickable cards
  padded = true,
  className = '',
  children,
  ...rest
}) {
  return (
    <Component
      className={clsx(
        'bg-white rounded-2xl border shadow-sm',
        accent ? `border-l-4 ${accent} border-gray-200` : 'border-gray-200',
        padded && 'p-4',
        interactive && 'hover:shadow-md hover:-translate-y-0.5 transition-all cursor-pointer',
        className
      )}
      {...rest}
    >
      {children}
    </Component>
  );
}
